import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import productReducer from "./products/reducer";

const rootReducer = combineReducers({
  products: productReducer,
});

const store = createStore(rootReducer, composeWithDevTools());

export default store;
